export enum StepStatus {
    // The step is available to be performed by a user
    available = 'available',
    // The step had status 'available' before, but may not run anymore
    cancelled = 'cancelled',
    // Running the step has generated an error
    failed = 'failed',
    // The step has finished running
    finished = 'finished',
    // A user is performing this step (saved as draft)
    inProgress = 'inProgress',
    // The step has been finished in the past, but is now obsolete because e.g. the related activity got cancelled
    obsolete = 'obsolete',
    // The step is scheduled and will be finished on a specific time
    scheduled = 'scheduled',
}

export function isStepStatus(value: unknown): value is StepStatus {
    return (
        value === StepStatus.available ||
        value === StepStatus.cancelled ||
        value === StepStatus.failed ||
        value === StepStatus.finished ||
        value === StepStatus.inProgress ||
        value === StepStatus.obsolete ||
        value === StepStatus.scheduled
    );
}
